// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICarrierDto } from './ICarrierDto';
import {
    ICarrierDtoFromJSON,
    ICarrierDtoFromJSONTyped,
    ICarrierDtoToJSON,
    ICarrierDtoToJSONTyped,
} from './ICarrierDto';

/**
 * 
 * @export
 * @interface ICarrierConfigDto
 */
export interface ICarrierConfigDto {
    /**
     * 
     * @type {number}
     * @memberof ICarrierConfigDto
     */
    id?: number;
    /**
     * 
     * @type {ICarrierDto}
     * @memberof ICarrierConfigDto
     */
    carrier?: ICarrierDto;
    /**
     * 
     * @type {string}
     * @memberof ICarrierConfigDto
     */
    submitter_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ICarrierConfigDto
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ICarrierConfigDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICarrierConfigDto
     */
    organization_path?: string;
    /**
     * 
     * @type {Date}
     * @memberof ICarrierConfigDto
     */
    service_date_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICarrierConfigDto
     */
    service_date_to?: Date;
    /**
     * 
     * @type {string}
     * @memberof ICarrierConfigDto
     */
    purpose_type?: ICarrierConfigDtoPurposeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ICarrierConfigDto
     */
    claim_autopay_type?: ICarrierConfigDtoClaimAutopayTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ICarrierConfigDto
     */
    is_dependent_deidentified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICarrierConfigDto
     */
    is_dependent_autocreated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ICarrierConfigDto
     */
    status_type?: ICarrierConfigDtoStatusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ICarrierConfigDto
     */
    claim_payee_type?: ICarrierConfigDtoClaimPayeeTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ICarrierConfigDto
     */
    amount_types?: Array<ICarrierConfigDtoAmountTypesEnum>;
}

/**
* @export
* @enum {string}
*/
export enum ICarrierConfigDtoPurposeTypeEnum {
    CLAIM_CREATION = 'CLAIM_CREATION',
    ADJUDICATION = 'ADJUDICATION'
}
/**
* @export
* @enum {string}
*/
export enum ICarrierConfigDtoClaimAutopayTypeEnum {
    AUTO = 'AUTO',
    CLICK = 'CLICK',
    EMPLOYEE_CHOICE = 'EMPLOYEE_CHOICE'
}
/**
* @export
* @enum {string}
*/
export enum ICarrierConfigDtoStatusTypeEnum {
    ACTIVE = 'ACTIVE',
    DISABLED = 'DISABLED'
}
/**
* @export
* @enum {string}
*/
export enum ICarrierConfigDtoClaimPayeeTypeEnum {
    PARTICIPANT = 'PARTICIPANT',
    PROVIDER = 'PROVIDER',
    EMPLOYEE_CHOICE = 'EMPLOYEE_CHOICE'
}
/**
* @export
* @enum {string}
*/
export enum ICarrierConfigDtoAmountTypesEnum {
    COINSURANCE = 'COINSURANCE',
    COPAY = 'COPAY',
    PATIENT_RESPONSIBILITY = 'PATIENT_RESPONSIBILITY',
    DEDUCTIBLE = 'DEDUCTIBLE',
    MIXED = 'MIXED'
}


/**
 * Check if a given object implements the ICarrierConfigDto interface.
 */
export function instanceOfICarrierConfigDto(value: object): value is ICarrierConfigDto {
    return true;
}

export function ICarrierConfigDtoFromJSON(json: any): ICarrierConfigDto {
    return ICarrierConfigDtoFromJSONTyped(json, false);
}

export function ICarrierConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICarrierConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'carrier': json['carrier'] == null ? undefined : ICarrierDtoFromJSON(json['carrier']),
        'submitter_id': json['submitter_id'] == null ? undefined : json['submitter_id'],
        'description': json['description'] == null ? undefined : json['description'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'service_date_from': json['service_date_from'] == null ? undefined : (new Date(json['service_date_from'])),
        'service_date_to': json['service_date_to'] == null ? undefined : (new Date(json['service_date_to'])),
        'purpose_type': json['purpose_type'] == null ? undefined : json['purpose_type'],
        'claim_autopay_type': json['claim_autopay_type'] == null ? undefined : json['claim_autopay_type'],
        'is_dependent_deidentified': json['is_dependent_deidentified'] == null ? undefined : json['is_dependent_deidentified'],
        'is_dependent_autocreated': json['is_dependent_autocreated'] == null ? undefined : json['is_dependent_autocreated'],
        'status_type': json['status_type'] == null ? undefined : json['status_type'],
        'claim_payee_type': json['claim_payee_type'] == null ? undefined : json['claim_payee_type'],
        'amount_types': json['amount_types'] == null ? undefined : json['amount_types'],
    };
}

export function ICarrierConfigDtoToJSON(json: any): ICarrierConfigDto {
    return ICarrierConfigDtoToJSONTyped(json, false);
}

export function ICarrierConfigDtoToJSONTyped(value?: ICarrierConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'carrier': ICarrierDtoToJSON(value['carrier']),
        'submitter_id': value['submitter_id'],
        'description': value['description'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'service_date_from': value['service_date_from'] == null ? undefined : ((value['service_date_from']).toISOString()),
        'service_date_to': value['service_date_to'] == null ? undefined : ((value['service_date_to']).toISOString()),
        'purpose_type': value['purpose_type'],
        'claim_autopay_type': value['claim_autopay_type'],
        'is_dependent_deidentified': value['is_dependent_deidentified'],
        'is_dependent_autocreated': value['is_dependent_autocreated'],
        'status_type': value['status_type'],
        'claim_payee_type': value['claim_payee_type'],
        'amount_types': value['amount_types'],
    };
}

